var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForkliftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_12021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 11.6667H6.24935C5.10018 11.6667 4.16602 10.7317 4.16602 9.58337V3.75004C4.16602 3.52004 4.35268 3.33337 4.58268 3.33337H7.49935C8.39685 3.33337 9.19102 3.90587 9.47602 4.75754L11.596 11.1175C11.6385 11.2442 11.6168 11.3842 11.5385 11.4934C11.4602 11.6025 11.3352 11.6667 11.2002 11.6667ZM4.99935 4.16671V9.58337C4.99935 10.2725 5.56018 10.8334 6.24935 10.8334H10.6227L8.68518 5.02171C8.51518 4.51004 8.03768 4.16671 7.49935 4.16671H4.99935Z",
    fill: "#FEB111",
    stroke: "#FEB111",
    strokeWidth: 0.346154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 15.8334H11.25C11.02 15.8334 10.8333 15.6467 10.8333 15.4167C10.8333 15.1867 11.02 15 11.25 15H12.5V11.6667H6.25C5.10083 11.6667 4.16667 10.7317 4.16667 9.58337V9.16671H2.08333C1.39417 9.16671 0.833333 9.72754 0.833333 10.4167V14.5834C0.833333 14.8134 1.02083 15 1.25 15H2.08333C2.31333 15 2.5 15.1867 2.5 15.4167C2.5 15.6467 2.31333 15.8334 2.08333 15.8334H1.25C0.560833 15.8334 0 15.2725 0 14.5834V10.4167C0 9.26837 0.934167 8.33337 2.08333 8.33337H4.58333C4.81333 8.33337 5 8.52004 5 8.75004V9.58337C5 10.2725 5.56083 10.8334 6.25 10.8334H12.9167C13.1467 10.8334 13.3333 11.02 13.3333 11.25V15.4167C13.3333 15.6467 13.1467 15.8334 12.9167 15.8334Z",
    fill: "#FEB111",
    stroke: "#FEB111",
    strokeWidth: 0.346154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 15.8333H5.41667C5.18667 15.8333 5 15.6467 5 15.4167C5 15.1867 5.18667 15 5.41667 15H7.91667C8.14667 15 8.33333 15.1867 8.33333 15.4167C8.33333 15.6467 8.14667 15.8333 7.91667 15.8333Z",
    fill: "#FEB111",
    stroke: "#FEB111",
    strokeWidth: 0.346154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 15.8333H12.9167C12.6867 15.8333 12.5 15.6467 12.5 15.4167V2.91667C12.5 2.68667 12.6867 2.5 12.9167 2.5C13.1467 2.5 13.3333 2.68667 13.3333 2.91667V15H19.5833C19.8133 15 20 15.1867 20 15.4167C20 15.6467 19.8133 15.8333 19.5833 15.8333Z",
    fill: "#FEB111",
    stroke: "#FEB111",
    strokeWidth: 0.346154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74935 17.5C2.60018 17.5 1.66602 16.565 1.66602 15.4167C1.66602 14.2684 2.60018 13.3334 3.74935 13.3334C4.89852 13.3334 5.83268 14.2684 5.83268 15.4167C5.83268 16.565 4.89852 17.5 3.74935 17.5ZM3.74935 14.1667C3.06018 14.1667 2.49935 14.7275 2.49935 15.4167C2.49935 16.1059 3.06018 16.6667 3.74935 16.6667C4.43852 16.6667 4.99935 16.1059 4.99935 15.4167C4.99935 14.7275 4.43852 14.1667 3.74935 14.1667Z",
    fill: "#FEB111",
    stroke: "#FEB111",
    strokeWidth: 0.346154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 17.5C8.43417 17.5 7.5 16.565 7.5 15.4167C7.5 14.2684 8.43417 13.3334 9.58333 13.3334C10.7325 13.3334 11.6667 14.2684 11.6667 15.4167C11.6667 16.565 10.7325 17.5 9.58333 17.5ZM9.58333 14.1667C8.89417 14.1667 8.33333 14.7275 8.33333 15.4167C8.33333 16.1059 8.89417 16.6667 9.58333 16.6667C10.2725 16.6667 10.8333 16.1059 10.8333 15.4167C10.8333 14.7275 10.2725 14.1667 9.58333 14.1667Z",
    fill: "#FEB111",
    stroke: "#FEB111",
    strokeWidth: 0.346154
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_12021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkliftIcon);
export default __webpack_public_path__ + "static/media/forklift-icon.062ba37cbfa37ff9ef0b763ccd48d768.svg";
export { ForwardRef as ReactComponent };